import React from 'react';
import PropTypes from 'prop-types';

import { Configure, Index } from 'react-instantsearch-dom';
import { ALGOLIA_INDEX_NAME } from 'commons/constants';
import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
import { CATEGORY_INDEX_MAPPING, SearchCount } from '../../commons/helpers';
import ProductSearchCount from './ProductSearchCount';

const SearchDesktopSidebarHeader = ({ index, onIndexChange, searchState }) => {
  const isProductsSearch = index === ALGOLIA_INDEX_NAME.PRODUCTS;
  const { loading } = useProductListingPageContext() ?? {};

  if (isProductsSearch && loading) {
    return null;
  }

  return (
    <div className="lg:pb-8 lg:min-w-[257px] lg:pr-8 lg:w-[257px] pr-6">
      <div className="mb-[25px]">
        <div className="text-base font-bold text-gray px-0 py-4">
          Refine by:
        </div>
        <div className="text-base text-gray font-normal">
          <Index indexName={ALGOLIA_INDEX_NAME.PRODUCTS}>
            <Configure
              facets={['*']}
              facetFilters={searchState.configure.facetFilters}
              numericFilters={[
                'item_availability<2',
                'visibility>0',
                'visibility<4',
              ]}
              getRankingInfo
            />
            <ProductSearchCount
              title="Products"
              id={CATEGORY_INDEX_MAPPING.products}
              selectedOption={index}
              indexClick={onIndexChange}
            />
          </Index>
          <Index indexName={ALGOLIA_INDEX_NAME.CATEGORIES}>
            <Configure
              numericFilters={['fk_store_id=1']}
              facetFilters={['is_searchable:1']}
              getRankingInfo
            />
          </Index>
          <Index indexName={ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS}>
            <Configure
              facets={['*']}
              numericFilters=""
              facetFilters={searchState.configure.facetFilters}
            />
            <SearchCount
              title="Customer Photos"
              id={CATEGORY_INDEX_MAPPING['customer photos']}
              selectedOption={index}
              indexClick={onIndexChange}
            />
          </Index>
          <Index indexName={ALGOLIA_INDEX_NAME.REVIEWS}>
            <Configure facets={['*']} numericFilters="" facetFilters="" />
            <SearchCount
              title="Reviews"
              id={CATEGORY_INDEX_MAPPING.reviews}
              selectedOption={index}
              indexClick={onIndexChange}
            />
          </Index>
          <Index indexName={ALGOLIA_INDEX_NAME.STATIC_PAGES}>
            <Configure
              numericFilters={[
                'is_active=1',
                'show_in_search=1',
                'fk_store_id=1',
              ]}
            />
            <SearchCount
              title="Pages"
              id={CATEGORY_INDEX_MAPPING.pages}
              selectedOption={index}
              indexClick={onIndexChange}
            />
          </Index>
          <Index indexName={ALGOLIA_INDEX_NAME.PRODUCTS}>
            <Configure
              facets={['*']}
              facetFilters={searchState.configure.facetFilters}
              numericFilters={[
                'item_availability<2',
                'visibility>0',
                'visibility<4',
              ]}
              getRankingInfo
            />
          </Index>
        </div>
      </div>
    </div>
  );
};

SearchDesktopSidebarHeader.propTypes = {
  searchState: PropTypes.shape({
    query: PropTypes.string,
    configure: {
      facetFilters: PropTypes.string,
      facets: PropTypes.array,
    },
    hitsPerPage: 12,
    page: 1,
  }),
  index: PropTypes.string,
  onIndexChange: PropTypes.func,
};

export default SearchDesktopSidebarHeader;
